import { defineConfig } from '@chakra-ui/react';

const tokens = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: 'var(--font-geist-mono)' },
        body: { value: 'var(--font-geist-mono)' },
      },
    },
  },
});

export default tokens;
